'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = RoundedButton;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _caligramReact = require('caligram-react');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RoundedButton(props) {
  return _react2.default.createElement(_caligramReact.Button, (0, _extends3.default)({ className: 'RoundedButton', type: 'primary' }, props));
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RoundedButton.js
// module id = 1086
// module chunks = 0